export default __webpack_public_path__ + "static/media/grafema_ummi_19.284a8acf.jpg";